const state = {
    currentUser: localStorage.getItem('currentUser') || null,
    fullName: null || localStorage.getItem('fullName'),
    organizationSettings: null || localStorage.getItem('organizationSettings')
}

const mutations = {
    SET_USER(state, newValue){
        state.currentUser = JSON.stringify(newValue)
        saveState('currentUser', newValue)
    },
    DELETE_USER(state){
        state.currentUser = null
        state.fullName = null
        deleteState('currentUser')
        localStorage.clear()
    },
    SET_FULL_NAME(state, payload){
        state.fullName = payload
        localStorage.setItem('fullName', payload)
    },
    SET_ORGANIZATION_SETTING(state, payload){
        state.organizationSetting = payload
       saveState('organizationSettings', payload)
    }
}

const actions = {
    login({ commit }, variables ){
        commit('SET_USER', variables)
        commit('SET_FULL_NAME', variables.fullName)
    },
    logout({ commit }){
        commit('DELETE_USER')
    },
    organizationSettingAction({ commit }, payload){
        commit('SET_ORGANIZATION_SETTING', payload)
    }
}

const getters = {
    loggedIn(state){
        return !!state.currentUser
    },
    getPermissions(state){
        if(state.currentUser !== null){
            return JSON.parse(state.currentUser).permissions
        }
        return []
    },
    getFullName(state){
        return state.fullName
    },
    getOrganizationSetting(state){
        if(state.organizationSetting !== null){
            return JSON.parse(state.organizationSetting)
        }
        return {}
    }
}

const saveState = (key, value) =>{
    localStorage.setItem(key, JSON.stringify(value))
}

const deleteState = ( key ) => {
    localStorage.removeItem(key)
    localStorage.clear()
}

export {
    state,
    mutations,
    actions,
    getters
}